// src/defaultBrandTheme.js

const DefaultAssistantConfiguration = {
    searchBar: {
        searchIconSelector: "",
        searchBarSiblingSelector: "",
        searchBarAnimation: "right-to-left"
    },
    searchWithAiButtonContainerSelector: "",
    cartAssistant: {
        containerSelector: "",
        header: ""
    },
    hideOutOfStockItems: true
};

export default DefaultAssistantConfiguration;